import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import type { User } from '@supabase/auth-js';

export const useAuth = () => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthChecking, setIsAuthChecking] = useState(true);

  useEffect(() => {
    // Initial session check
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        setIsAuthenticated(true);
        setCurrentUser(session.user);
      }
      setIsAuthChecking(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      const user = session?.user ?? null;
      setCurrentUser(user);
      setIsAuthenticated(!!user);
      setIsAuthChecking(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  return { currentUser, isAuthenticated, isAuthChecking };
};
